<template>
  <div>
    <v-card-title>
      Is this a brokerage company?
      <v-checkbox
        hide-details
        class="ml-3"
        :model-value="isBrokerage"
        @update:model-value="$emit('update:isBrokerage', $event)"
      />
    </v-card-title>
    <v-card-text v-if="isBrokerage">
      <v-row>
        <v-col cols="12">
          <v-text-field
            label="Legal Entity Name"
            :model-value="modelValue.legal_name"
            @update:model-value="updateField('legal_name', $event)"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="8">
          <v-text-field
            label="Broker License #"
            :model-value="modelValue.number"
            @update:model-value="updateField('number', $event)"
          />
        </v-col>
        <v-col cols="4">
          <StateSelect
            :model-value="modelValue.state"
            @update:model-value="updateField('state', $event)"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-text-field
            label="Tax ID #"
            :model-value="modelValue.taxId"
            @update:model-value="updateField('taxId', $event)"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </div>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue';

import { ICompanyBrokerLicense } from '@/bundles/Companies/types';

import StateSelect from '@/bundles/App/components/inputs/StateSelect.vue';

export default defineComponent({
  name: 'CompanyBrokerageSection',

  components: { StateSelect },

  props: {
    modelValue: {
      type: Object as PropType<ICompanyBrokerLicense>,
      required: true
    },
    isBrokerage: Boolean
  },

  emits: ['update:isBrokerage', 'update:modelValue'],

  methods: {
    updateField (key: string, value: string) {
      this.$emit('update:modelValue', { ...this.modelValue, [key]: value });
    }
  }
})
</script>
